
<div class="shared-filters">
  <align small-gap>
    <search-area
      v-model="localQuery"
      class="search-area-filters"
      :placeholder="placeholder"
      :options="recentSearches"
      :icon="searchIcon"
      @iconClick="$emit('searchIconClick')"
    />

    <div v-show="!hideFilters">
      <icon-button
        icon="tune"
        @click="showFilterModal = true"
      />
    </div>
  </align>

  <modal
    title="Filter"
    size="side"
    :open="showFilterModal"
    @close="closeModal"
  >
    <div class="filters">
      <multiselect
        v-if="showGraders"
        v-model="localFilters.graders"
        label="Graders"
        :options="graderOptions"
      />

      <select-input
        v-if="showHasMatches"
        v-model="localFilters.hasMatches"
        label="Has matches"
        :options="hasMatchesOptions"
      />

      <multiselect
        v-if="showCategories"
        v-model="localFilters.categories"
        label="Categories"
        :options="categoryOptions"
      />

      <div v-if="showValues" class="input-group">
        <currency-input
          v-model="localFilters.minValue"
          label="Min Value"
        />

        <currency-input
          v-model="localFilters.maxValue"
          label="Max Value"
        />
      </div>

      <div v-if="showPrices" class="input-group">
        <currency-input
          v-model="localFilters.minPrice"
          label="Min Price"
        />

        <currency-input
          v-model="localFilters.maxPrice"
          label="Max Price"
        />
      </div>

      <div v-if="showPops" class="input-group">
        <text-input
          v-model.trim="localFilters.minPop"
          type="number"
          label="Min Pop"
        />

        <text-input
          v-model.trim="localFilters.maxPop"
          type="number"
          label="Max Pop"
        />
      </div>

      <div v-if="showCards" class="input-group">
        <text-input
          v-model.trim="localFilters.minCards"
          type="number"
          label="Min Cards"
        />

        <text-input
          v-model.trim="localFilters.maxCards"
          type="number"
          label="Max Cards"
        />
      </div>

      <div v-if="showDates" class="input-group">
        <date-input
          v-model="localFilters.minDate"
          label="Min Date"
          has-clear
          :max="maxDate"
        />

        <date-input
          v-model="localFilters.maxDate"
          label="Max Date"
          has-clear
          :max="maxDate"
        />
      </div>

      <select-input
        v-if="showCollectionStatus"
        v-model="localFilters.sold"
        label="Collection/Sold"
        :options="soldOptions"
      />

      <div v-if="showYears" class="input-group">
        <select-input
          v-model="localFilters.minYear"
          label="Min Year"
          :options="yearOptions"
        />

        <select-input
          v-model="localFilters.maxYear"
          label="Max Year"
          :options="yearOptions"
        />
      </div>

      <multiselect
        v-if="showConditions"
        v-model="localFilters.conditions"
        label="Conditions"
        :options="conditionOptions"
      />

      <multiselect
        v-if="showPlatforms"
        v-model="localFilters.platforms"
        label="Platforms"
        :options="salesPlatforms"
      />

      <select-input
        v-if="showListingType"
        v-model="localFilters.listingType"
        label="Listing Type"
        :options="listingTypeOptions"
      />

      <tag-input
        v-if="showTags"
        v-model="localFilters.tags"
        label="Tags"
      />

      <text-input
        v-if="showSeller"
        v-model.trim="localFilters.seller"
        label="Seller ID"
      />

      <select-input
        v-if="showVerified"
        v-model="localFilters.verified"
        label="Verified"
        :options="verifiedOptions"
      />

      <select-input
        v-if="showCertified"
        v-model="localFilters.certified"
        label="Certified"
        :options="certifiedOptions"
      />

      <select-input
        v-if="showBestOfferStatus"
        v-model="localFilters.bestOfferStatus"
        label="Best Offer Status"
        :options="bestOfferStatusOptions"
      />
    </div>

    <template #footer>
      <align small-gap>
        <btn @click="apply">
          Apply
        </btn>

        <btn kind="secondary" @click="clear">
          Clear
        </btn>
      </align>
    </template>
  </modal>
</div>
